// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"df69883b","367":"1ff17fa5","453":"85e692aa","557":"f2204454","563":"563458c0","787":"b209e448","862":"36485380","887":"616fb5f5","956":"ef19c0fa"}[chunkId] + ".chunk.js";
};